// libs.
import React from 'react';
import { Card } from 'react-bootstrap';

// hooks.
import { useGetCurrentOrchestratorQuery } from '../../store/services/orchestrator-pricing-committee.endpoints';

// types.
import { IWorkflowStep, IWorkflowResponse } from '../../interfaces/interfaces';

interface InProgressCardData {
  stepName: string;
  owner_process: string;
  retry_policy_by: string;
  comment: string;
  created_at: string;
}

const getLastRetriedResponse = (
  responses: IWorkflowResponse[]
): IWorkflowResponse | undefined => {
  for (let index = responses.length - 1; index >= 0; index -= 1) {
    if (responses[index].status === 'RETRIED') return responses[index];
  }
  return undefined;
};

const buildCardFromStep = (step: IWorkflowStep): InProgressCardData | null => {
  const retried = getLastRetriedResponse(step.responses);
  if (!retried) return null;

  const detail = (retried.detail ?? {}) as Record<string, unknown>;

  const owner = detail.owner_process as string | undefined;
  const retriedBy = detail.retry_policy_by as string | undefined;
  const comment = retried.comment;

  const hasAllRequired =
    Boolean(owner) && Boolean(retriedBy) && Boolean(comment);
  if (!hasAllRequired) return null;

  return {
    stepName: step.name,
    owner_process: owner as string,
    retry_policy_by: retriedBy as string,
    comment: comment as string,
    created_at: retried.created_at,
  };
};

interface InProgressStepsCardsProps {
  nid: string;
}

export const InProgressStepsCards: React.FC<InProgressStepsCardsProps> = ({
  nid,
}) => {
  const country = localStorage.getItem('country') ?? undefined;

  const { data } = useGetCurrentOrchestratorQuery({
    country,
    nid,
  });

  const steps: IWorkflowStep[] = data?.workflow_steps || [];

  const cards: InProgressCardData[] = steps
    .map(buildCardFromStep)
    .filter(Boolean) as InProgressCardData[];

  if (cards.length === 0) return null;

  return (
    <div data-testid="in-progress-steps-cards">
      {cards.map(card => (
        <Card key={`${card.stepName}-${card.created_at}`}>
          <Card.Body>
            <div className="mb-1 card-sub-title">
              <strong>Fecha: </strong>
              {new Date(card.created_at).toLocaleString()}
            </div>
            <div className="mb-1 card-sub-title">
              <strong>Proceso:</strong> {card.stepName}
            </div>
            <div className="mb-1 card-sub-title">
              <strong>Procesado por:</strong> {card.retry_policy_by}
            </div>
            <div className="mb-1 card-sub-title">
              <strong>Reintentado por:</strong> {card.owner_process}
            </div>
            <div className="mb-1 card-sub-title">
              <strong>Comentario: </strong>
              {card.comment}
            </div>
          </Card.Body>
        </Card>
      ))}
    </div>
  );
};

export default InProgressStepsCards;
